import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { ILightZone } from '../../../../../types/Lights/lightZoneInterfaces';
import { SideBarSimpleMethodWithValue } from '../../../../../components/commons/SideBarComponents/MethodWithValueItem/sideBarMethodWithValueItem';
import Strings from '../../../../../i18n';
import {
  useGetConfigurationIdMutation,
  useUpdateChannelNameMutation,
  useUpdateLightNameMutation
} from '../../../../../services/lightsZones/lightsZonesService';

interface ISingleDetailsLighZoneProps {
  lightZone: ILightZone;
  reloadTable: () => void;
  closeSideBar: () => void;
}
export const SingleDetailsLighZone = ({
  lightZone,
  reloadTable,
  closeSideBar
}: ISingleDetailsLighZoneProps) => {
  const [name, setName] = useState(lightZone?.name);
  const [successUpdateName, setSuccessUpdateName] = useState(false);
  const xSeries = 'X Series';
  const [updateLight, { isSuccess: isSuccessUpdateLight }] =
    useUpdateLightNameMutation();

  const [updateChannel, { isSuccess: isSuccessUpdateChannel }] =
    useUpdateChannelNameMutation();

  const [getIdConfig, { data }] = useGetConfigurationIdMutation();

  useEffect(() => {
    if (xSeries) {
      getIdConfig(lightZone.id);
    }
  }, []);
  const updateLightZoneName = () => {
    if (name) {
      if (lightZone.controllerTypeName !== xSeries) {
        updateLight({
          lightId: lightZone.id,
          name,
          pinName: lightZone.pinName
        });
      } else {
        updateChannel({ lightId: data?.id || 0, name });
      }
    }
  };

  useEffect(() => {
    if (isSuccessUpdateLight || isSuccessUpdateChannel) {
      toast.success(Strings.lightsZones.changeNameSuccess);
      reloadTable();
      closeSideBar();
    }
  }, [isSuccessUpdateLight, isSuccessUpdateChannel]);

  return (
    <StyledContainerItems>
      <StyledTitleSideBar>{lightZone?.name}</StyledTitleSideBar>
      {lightZone && !lightZone.isZone && (
        <SideBarSimpleMethodWithValue
          label={Strings.common.name}
          type="inputText"
          currentValue={name}
          action={() => {
            updateLightZoneName();
          }}
          onChange={(e) => {
            setName(e.target.value);
          }}
          successAction={false}
          textSuccess="success"
          buttonLabel="Change Name"
        />
      )}
    </StyledContainerItems>
  );
};
